import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router-dom'
import Container from '@orionx-dev/orionsoft-parts/lib/components/Container'
import { FaTwitterSquare } from 'react-icons/fa'
import { FaFacebookSquare } from 'react-icons/fa'
import { FaInstagram } from 'react-icons/fa'
import { FaGithub } from 'react-icons/fa'

export default class Footer extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <Container>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <div className={styles.title}>Productos</div>
              <Link className={styles.link} to="/products/wallet">
                Billetera
              </Link>
              <Link className={styles.link} to="/products/buy">
                Compra y venta
              </Link>
              <Link className={styles.link} to="/products/exchange">
                Exchange
              </Link>
            </div>
            <div className="col-xs-12 col-sm-3">
              <div className={styles.title}>Recursos</div>
              <a
                className={styles.link}
                href="https://orionx.crisp.help/"
                rel="noopener noreferrer"
                target="_blank">
                Soporte
              </a>
              <Link className={styles.link} to="/security">
                Seguridad
              </Link>
              <Link className={styles.link} to="/bounty-program">
                Bounty Program
              </Link>
              <Link className={styles.link} to="/introducing-brokers">
                Introducing Brokers
              </Link>
              <Link className={styles.link} to="/rates">
                Tarifas
              </Link>
              <Link className={styles.link} to="/global">
                Países
              </Link>
              <Link className={styles.link} to="/terms-and-conditions">
                Términos y condiciones
              </Link>
              <Link className={styles.link} to="/privacy-policy">
                Política de privacidad
              </Link>
            </div>
            <div className="col-xs-12 col-sm-3">
              <div className={styles.title}>Mi cuenta</div>
              <Link className={styles.link} to="/accounts">
                Mis cuentas
              </Link>
              <Link className={styles.link} to="/trade">
                Comprar y vender
              </Link>
              <Link className={styles.link} to="/settings/security">
                Seguridad
              </Link>
              <Link className={styles.link} to="/settings/kyc">
                Verificación
              </Link>
            </div>
            <div className="col-xs-12 col-sm-3">
              <div className={styles.title}>Redes Sociales</div>
              <a
                className={styles.link}
                href="https://www.facebook.com/orionx.crypto/"
                rel="noopener noreferrer"
                target="_blank">
                <FaFacebookSquare size={20} /> FaFacebookSquare
              </a>
              <a
                className={styles.link}
                href="https://www.instagram.com/orionx.crypto/"
                rel="noopener noreferrer"
                target="_blank">
                <FaInstagram size={20} /> FaInstagram
              </a>

              <a
                className={styles.link}
                href="https://twitter.com/orionx"
                rel="noopener noreferrer"
                target="_blank">
                <FaTwitterSquare size={20} /> FaTwitterSquare
              </a>
              <a
                className={styles.link}
                href="https://github.com/orionx-dev/"
                rel="noopener noreferrer"
                target="_blank">
                <FaGithub size={20} /> GitHub
              </a>
            </div>
          </div>
          <div className={styles.logo}>
            <Link to="/">
              <img src="/logo-white.svg" alt="logo" />
            </Link>
          </div>
        </Container>
      </div>
    )
  }
}
